import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  errorHanlders: Array<IErrorHandler> = [];
  constructor(
    router: Router,
    toastrService: NbToastrService
  ) {
    this.registerHanlder(new AuthenticationErrorHanlder(toastrService, router));
    this.registerHanlder(new AuthorizationErrorHandler(toastrService));
    this.registerHanlder(new PageNotFoundErrorHandler(toastrService, router));
    this.registerHanlder(new InternalServerErrorHandler(toastrService));
    this.registerHanlder(new InternalServerErrorHandler(toastrService));
    this.registerHanlder(new ServerUnavailableErrorHandler(toastrService));
    this.registerHanlder(new ServerCannotConnect(toastrService));
    this.registerHanlder(new BadRequestErrorHanlder(toastrService));
    this.registerHanlder(new ConfictErrorHanlder(toastrService));
  }


  handleErr(err: HttpErrorResponse, url: string): Observable<any> {
    const hanlder = this.errorHanlders.find(x => x.getError() === err.status);
    if (hanlder) {
      hanlder.onError(err, url);
    }
    return throwError(err.error);
  }

  registerHanlder(hanler: IErrorHandler) {
    this.errorHanlders.push(hanler);
  }
}

interface IErrorHandler {
  getError(): number;
  onError(error: HttpErrorResponse, url: string): void
}

abstract class BaseErrorHandler {
  protected errorCode: number;
  constructor(protected toastrService: NbToastrService) {

  }

  getError() {
    return this.errorCode;
  }

  onError(error: HttpErrorResponse, url: string) {
    if (this.isGlobalHandler(url) && error && error.error) {
      this.toastrService.danger("", error.error.error.message);
    }
  }

  protected isGlobalHandler(url: string) {
    let result = false;
    const isUserGlobalHandler = url.split('#')[1];
    if (isUserGlobalHandler == 'true') {
      result = true;
    }
    return result;
  }

}

class AuthenticationErrorHanlder extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService, private router: Router) {
    super(toastrService);
    this.errorCode = 401;
  }

  onError(error: HttpErrorResponse, url: string) {
    if (this.isGlobalHandler(url)) {
      this.router.navigateByUrl(`/auth/login`).then((result) => {
        if (result) {
          this.toastrService.warning('', 'Your login session is expired');
        }
      });
    }
  }
}

class AuthorizationErrorHandler extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService) {
    super(toastrService);
    this.errorCode = 403;
  }
  onError(error: HttpErrorResponse, url: string) {
    if (this.isGlobalHandler(url)) {
      this.toastrService.danger('', 'Authorization');
    }
  }
}

class PageNotFoundErrorHandler extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService, private router: Router) {
    super(toastrService);
    this.errorCode = 404;
  }

  onError(error: HttpErrorResponse, url: string) {
    if (this.isGlobalHandler(url)) {
      // this.toastrService.warning('', 'Page Not Found');
      this.router.navigateByUrl(`/error/404`);
    }
  }
}

class InternalServerErrorHandler extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService) {
    super(toastrService);
    this.errorCode = 500;
  }
}

class ServerUnavailableErrorHandler extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService) {
    super(toastrService);
    this.errorCode = 503;
  }
  onError(error: HttpErrorResponse, url: string) {
    if (this.isGlobalHandler(url)) {
      this.toastrService.danger('', 'Server Unavailable');
    }
  }
}

class ServerCannotConnect extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService) {
    super(toastrService);
    this.errorCode = 0;
  }
  onError(error: HttpErrorResponse, url: string) {
    if (this.isGlobalHandler(url)) {
      this.toastrService.danger('', 'Server Unavailable');
    }
  }
}

class BadRequestErrorHanlder extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService) {
    super(toastrService);
    this.errorCode = 400;
  }
}

class ConfictErrorHanlder extends BaseErrorHandler implements IErrorHandler {
  constructor(toastrService: NbToastrService) {
    super(toastrService);
    this.errorCode = 409;
  }
}
